// eslint-disable-next-line
import React from 'react' // Needed for styled() Extends

import styled from 'styled-components'
import * as AccountStyles from 'styles/account'

export const Breadcrumbs = styled(AccountStyles.Row)`
  justify-content: flex-start;
  a,
  span {
    font-size: 12px;
    font-weight: 700;
    padding: ${(props) => props.theme.space[1]}px 0 ${(props) => props.theme.space[1]}px
      ${(props) => props.theme.space[1]}px;
  }
  a {
    color: ${(props) => props.theme.colors.gray};
    text-decoration: none;
    &::after {
      margin-left: ${(props) => props.theme.space[1]}px;
      content: '/';
      display: inline-block;
    }
    &:first-child {
      padding: ${(props) => props.theme.space[1]}px 0;
    }
  }

  span {
    color: ${(props) => props.theme.colors.default};
  }
`
const { Column, Row, P, Link, Spacer } = AccountStyles
export { Column, Row, P, Link, Spacer }
